import {useState} from "react";
import PropTypes from "prop-types";

/**
 * A small styled link. Renders by capability so it is keyboard-accessible in
 * every mode (the old version was always an <a> with neither href nor keyboard
 * handling — clickable by mouse only):
 *  - `aProps.href` present  -> a real <a> (native keyboard/SR behavior);
 *  - `onClick` without href -> role="button" + tabIndex + Enter/Space handling;
 *  - neither                -> plain <span>, since it isn't interactive at all.
 */
const SimpleLink = (props) => {
    const [isHovered, setIsHovered] = useState(false)

    const hoverStyle = {
      color: props.hoverColor,
      textDecoration: 'underline',
      textDecorationColor: props.hoverColor,
      fontWeight:700
    }

    const nonHoverStyle = {
      color: props.color
    }

    const sharedProps = {
      style: isHovered ? hoverStyle : nonHoverStyle,
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      ...props.aProps,
    };

    if (props.aProps?.href) {
      // href listed explicitly (not just via the spread) so the element is
      // statically recognizable as a real link.
      return <a onClick={props.onClick} {...sharedProps} href={props.aProps.href}>{props.text}</a>;
    }

    if (props.onClick) {
      // A real <button> (reset to look like the link text): native keyboard
      // activation and focus semantics for free.
      const buttonReset = {
        background: 'none',
        border: 'none',
        padding: 0,
        font: 'inherit',
        cursor: 'pointer',
      };
      return (
        <button
          type="button"
          onClick={props.onClick}
          {...sharedProps}
          style={{ ...buttonReset, ...(isHovered ? hoverStyle : nonHoverStyle) }}
        >
          {props.text}
        </button>
      );
    }

    return <span {...sharedProps}>{props.text}</span>;
  }

  SimpleLink.propTypes = {
    hoverColor: PropTypes.string,
    color: PropTypes.string,
    text: PropTypes.node,
    onClick: PropTypes.func,
    aProps: PropTypes.object,
  };

  export default SimpleLink
